import { ObjectMapper } from 'json-object-mapper';
import { Model, OptionModel } from '../model';
import { IModel } from '../IModel';
import { CompetenceMatrixModel } from './competenceMatrix.model';

export class JobTitleGroupModel extends Model implements IModel<JobTitleGroupModel> {
    companyGroupId: string | undefined = undefined;
    companyRootId: string | undefined = undefined;
    code: string = '';
    name: string = '';
    description: string = '';
    recruitmentDescription: string = '';
    responsibilities: string = '';
    technicalRequirements: string = '';
    behavioralRequirements: string = '';
    foreignId: string | undefined = undefined;
    companyRootName: string | undefined = undefined;
    jobTitleFamilyId: string | undefined = undefined;
    jobTitleFamilyCompetenceMatrices?: CompetenceMatrixModel[] = [];
    competenceMatrices?: CompetenceMatrixModel[] = [];
    hasSeniority: boolean = false;
    isApprentice: boolean = false;

    static create(input: any): JobTitleGroupModel {
        return ObjectMapper.deserialize<JobTitleGroupModel>(JobTitleGroupModel, input);
    }

    public toJSON(): string {
        return ObjectMapper.serialize(this) as string;
    }

    toOption(): OptionModel {
        const label = `${this.code} - ${this.name}`;
        const description = this.companyRootName ? this.companyRootName : undefined;
        return { label, value: this.id, description } as OptionModel;
    }
}
